import React, { lazy, Suspense, ReactNode } from "react";
import { UxLoading } from "@imaginelearning/mps-ux-component-library";

const RemoteFeatureFlagProvider = lazy(() =>
  import("@imaginelearning/shared-components/FeatureFlagProvider").then((module) => ({
    default: module.FeatureFlagProvider
  }))
);

interface LazyProviderProps {
  children: ReactNode;
}

const LazyFlagProvider: React.FC<LazyProviderProps> = ({ children, ...props }) => (
  <Suspense fallback={<UxLoading text="Loading" />}>
    <RemoteFeatureFlagProvider {...props}>{children}</RemoteFeatureFlagProvider>
  </Suspense>
);

export default LazyFlagProvider;
